import React, { useContext } from 'react';
import { Space, Text } from '@cashfree-intl/coherent';
import CustomIcon from 'components/CustomIcons';
import { MerchantContext } from 'contexts/MerchantContext';
import { ENABLE_SHELL_V2 } from 'utils/constants';
import { StyledBannerCard } from '../styled';
import { BANNER_TEXT } from '../constants';

const WalletsBanner = () => {
  const { featureToggles = {}, isShellV2 } = useContext<any>(MerchantContext);

  const isShellV2Enabled =
    ENABLE_SHELL_V2 in featureToggles && featureToggles[ENABLE_SHELL_V2];

  const bannerMargin = () => {
    if (!isShellV2Enabled || (isShellV2Enabled && !isShellV2)) {
      return '0 -2rem 0 -8.125rem';
    }
    return '0 -2rem';
  };

  return (
    <div
      style={{
        background: 'linear-gradient(108deg, #240353 0%, #622FC7 100%)',
        margin: bannerMargin(),
      }}
      className="pl-6 pt-3 pr-6 pb-4"
    >
      <Space justifyContent="center">
        <Text variant="h28" color="white" strong>
          Unlock the Power of Refund Wallets
        </Text>
      </Space>
      <Space justifyContent="center" gap={25} className="pl-6 pr-6 pt-2">
        {BANNER_TEXT.map(data => (
          <StyledBannerCard direction="column" key={data.title}>
            <CustomIcon componentName="STARS" />
            <Text variant="h16" color="white" strong>
              {data.title}
            </Text>
            <Text variant="p14" color="white">
              {data.description}
            </Text>
          </StyledBannerCard>
        ))}
      </Space>
    </div>
  );
};

export default WalletsBanner;
